import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6">Privacy Policy</h1>

      <div className="text-sm text-gray-700 space-y-6">
        <p>This Privacy Policy explains how we collect, use, and protect your information.</p>

        <h2 className="text-lg font-semibold">General</h2>
        <p>
          Paykit Kenya Limited and its affiliates (hereinafter, Paykit, we, us or our) are committed to protecting and respecting your privacy. This Privacy Policy (together with our Terms of Use) governs our collection, processing and use of our Users' and visitors of our Sites' Personal Information.
        </p>

        <h2 className="text-lg font-semibold">Definitions</h2>
        <p>
          <strong>Paykit affiliates:</strong> subsidiaries, parent companies, and companies under common control.<br />
          <strong>Personal Information:</strong> any information which identifies you personally or which may help us to identify you.<br />
          <strong>Data subject:</strong> an identified or identifiable person (our User).<br />
          <strong>Data controller:</strong> a company which determines purposes and means of personal data processing.<br />
          <strong>Data processor:</strong> a company which processes personal data on behalf of the Data controller.<br />
          <strong>Our Sites:</strong> websites such as Paykit.africa, our mobile apps, and smart POS Devices.<br />
        </p>

        <h2 className="text-lg font-semibold">Who is Paykit</h2>
        <p>
          Paykit is a company registered in Kenya. Our office is at 4th Floor, Stellato Complex, Muthithi Road, Westlands, Nairobi. Established in 2023, Paykit offers Payment, Agency, and Merchant Services.
        </p>

        <h2 className="text-lg font-semibold">Collection and Use of Personal Information</h2>
        <p>
          We collect Personal Information when you use Paykit services or open an account. Types of data include your name, ID, address, email, phone number, IP address, banking details, and transaction data. This data is processed for service delivery, legal compliance, and fraud prevention.
        </p>

        <h2 className="text-lg font-semibold">Children's Personal Data</h2>
        <p>
          Our services are for users 18 and older. We do not process data from children under this age.
        </p>

        <h2 className="text-lg font-semibold">IP Addresses and Cookies</h2>
        <p>
          We collect IP and browser data for analytics. Cookies are used to enhance your experience and assess site performance. You can manage cookies via your browser settings. More at www.allaboutcookies.org.
        </p>

        <h2 className="text-lg font-semibold">Disclosure of Personal Information</h2>
        <p>
          We disclose Personal Information to service providers, affiliates, financial institutions, and regulatory bodies when necessary. These parties are contractually bound to protect your data.
        </p>

        <h2 className="text-lg font-semibold">International Data Transfers</h2>
        <p>
          Your data may be transferred to countries outside Kenya and the EU. We ensure protection via adequacy decisions or appropriate safeguards.
        </p>

        <h2 className="text-lg font-semibold">Your Rights</h2>
        <p>
          You may access, update, restrict, or request deletion of your data by emailing support@paykit.africa. We may verify your identity before fulfilling requests.
        </p>

        <h2 className="text-lg font-semibold">Security</h2>
        <p>
          We implement strong security measures including encryption, 2FA, and access control. Only authorized personnel can access Personal Information.
        </p>

        <h2 className="text-lg font-semibold">Links</h2>
        <p>
          Our site may contain links to third-party websites. We are not responsible for their content or privacy practices.
        </p>

        <h2 className="text-lg font-semibold">Retention and Disposal</h2>
        <p>
          We retain data for seven years for legal and compliance purposes. Once no longer needed, data is anonymized or securely deleted.
        </p>

        <h2 className="text-lg font-semibold">Marketing</h2>
        <p>
          You can opt in/out of marketing messages at registration or in your account settings. You can also contact support@paykit.africa to change preferences.
        </p>

        <h2 className="text-lg font-semibold">Data Protection Officer</h2>
        <p>
          Contact our DPO at compliance@paykit.africa. Our supervisory authority is the Office of the Data Protection Commissioner: https://www.odpc.go.ke/
        </p>

        <h2 className="text-lg font-semibold">Changes</h2>
        <p>
          This policy may change. If so, we will notify users via our site. Last updated: 25th February 2025.
        </p>

        <h2 className="text-lg font-semibold">Fraud and Scams Disclaimer</h2>
        <p>
          We do not charge for customer support. If you see suspicious activity claiming to be Paykit, email support@paykit.africa.
        </p>
      </div>
    </div>
  );
}
